"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"
import { ChangeBodyColor } from "app/(frontsite)/manifesto/ChangeBodyColor"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...props}>
      <ChangeBodyColor
        color={props.defaultTheme === "dark" ? "#000" : "#f4f0e9"}
      />
      {children}
    </NextThemesProvider>
  )
}
